const state = {
    marketingleads: [],
    marketingleadid: {},
    loading: false,
};

export default state;